<ng-container
  [ngTemplateOutletContext]="{ item: root, level: 1 }"
  [ngTemplateOutlet]="navList"
></ng-container>

<ng-template #navList let-item="item" let-level="level">
  <ul [class.expanded]="item.expanded" [ngClass]="'nav-level-' + level">
    @for (child of item.children; track child) {
      <li>
        <ng-container
          [ngTemplateOutletContext]="{ item: child }"
          [ngTemplateOutlet]="navLink"
        ></ng-container>
        @if (child.children) {
          <ng-container
            [ngTemplateOutletContext]="{ item: child, level: level + 1 }"
            [ngTemplateOutlet]="navList"
          ></ng-container>
        }
      </li>
    }
  </ul>
</ng-template>

<ng-template #navLink let-item="item">
  <a
    (click)="selected.emit(item)"
    [class.active]="item.active"
    [href]="item.url"
    [target]="item.target ?? '_self'"
    class="cep-nav"
  >
    @if (item.icon) {
      <ui-icon
        [faName]="item.icon.name"
        [faStyle]="item.icon.family"
      ></ui-icon>
    }
    {{ item.label }}
    @if (item.children?.length) {
      <ui-icon
        class="chevron"
        faName="chevron-right"
        faStyle="light"
      ></ui-icon>
    }
  </a>
</ng-template>
